import clsx from 'clsx'
import PropTypes from 'prop-types'

// Inhalt der Report-Einstellungen. Ohne readOnly ein div wie bisher. Mit
// readOnly (enforced ohne CUSTOM_REPORTS, schon gespeichert) wie in
// LockedSection ein disabled fieldset. Der Inhalt bleibt lesbar und im
// Accessibility-Tree, Toggles und Auswahl sind gesperrt. Elemente ohne native
// Sperre (die Dimensionen) prüfen readOnly selbst.
const ReadOnlyFieldset = ({ readOnly, className, children }) => {
  if (!readOnly) return <div className={className}>{children}</div>

  return (
    // min-w-0, sonst setzt fieldset min-width auf min-content
    <fieldset
      disabled
      className={clsx(className, 'min-w-0')}
      data-pricing-read-only=''
    >
      {children}
    </fieldset>
  )
}

ReadOnlyFieldset.propTypes = {
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
}

ReadOnlyFieldset.defaultProps = {
  readOnly: false,
  className: undefined
}

export default ReadOnlyFieldset
